import styles from "./dot.module.css";
import DotsImg from "../../../assets/imgs/dots.png";

export default function Dot932() {
  return (
    <div className={styles.dot932}>
      <img src={DotsImg} alt="circular-dots" />
    </div>
  );
}
